import { baseRequst,fileRequest } from "./Network";
import { customBaseURL } from 'config';
const request = async (apiFunc, ...args) => {
  try {
    const res = await apiFunc(...args);
    return res.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const bvaArtworksPage = async (data) => {
  return request(
    baseRequst,
    "/bvaArtworks/page",
    "post",
    data,
  );
};

export const bvaArtworksAdd = async (data) => {
  return request(
    baseRequst,
    "/bvaArtworks/add",
    "post",
    data,
  );
};

export const bvaArtworksRename = async (data) => {
  return request(
    baseRequst,
    "/bvaArtworks/update_name",
    "post",
    data,
  );
};

export const bvaTemplatePage = async (data) => {
  return request(
    baseRequst,
    "/bvaTemplate/page",
    "post",
    data,
  );
};

export const bvaArtworksDelete = async (artworkId) => {
  return request(
    baseRequst,
    `/bvaArtworks/delete/${artworkId}`,
    "get",
  );
};

export const favouritePage = async (data) => {
  return request(
    baseRequst,
    "/favourite/page",
    "post",
    data,
  );
};

export const favouriteAdd = async (data) => {
  return request(
    baseRequst,
    "/favourite/add",
    "post",
    data,
  );
};

export const favouriteRemove = async (data) => {
  return request(
    baseRequst,
    "/favourite/remove",
    "post",
    data,
  );
};

export const bvaTemplateRecommend = async (count) => {
  return request(
    baseRequst,
    "/bvaTemplate/recommend",
    "get",
    { count },
  );
};

export const imageToDrawio = async (file,title) => {
  const formData = new FormData();
  formData.append("file", file);
  return request(
    fileRequest,
    "/ai-image-tool/image-to-drawio",
    "post",
    formData,
    { params:{title} },
  );
};

export const updateStatus = async (data) => {
  return request(
    baseRequst,
    "/bvaTemplate/updateStatus",
    "post",
    data,
  );
};

export const serviceUrlList = async () => {
    return request(
        baseRequst,
        "/notify/serviceUrl/list",
        "get",
        {},
        {},
        customBaseURL
    );
};